function BikePolicyHolderHandler(Util, publicIDTransformer) {
	function handle(quoteRequest, userInput) {
		var mainPolicyholder = quoteRequest.policyHolders.filter(function (item) {
            return item['mainHolder'];
        })[0];

        var mainRider = quoteRequest.motorcycles[0].riders.filter(function (item) {
            return item['riderUsage'] == 'main';
		})[0];		
		
		if (mainPolicyholder.contact.publicID == mainRider.rider.person.publicID) {
            mainRider.rider.person.passwordQuestion = mainPolicyholder.contact.passwordQuestion;
            mainRider.rider.person.passwordAnswer = mainPolicyholder.contact.passwordAnswer;
            mainRider.rider.person.primaryPhone = mainPolicyholder.contact.primaryPhone;
            
			switch (mainPolicyholder.contact.primaryPhone) {
				case 'mobile':
					mainRider.rider.person.cellPhone = mainPolicyholder.contact.cellPhone;
					break;
				case 'home':
					mainRider.rider.person.homePhone = mainPolicyholder.contact.homePhone;
					break;
				case 'work':
					mainRider.rider.person.workPhone = mainPolicyholder.contact.workPhone;
					break;
            }
		}	

		return quoteRequest;
	}

	return {
		handle: handle
	}
};
